// Recovered compiled webpack factory 44707. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "isNavigatingToNewRootLayout", {
      enumerable: !0,
      get: function () {
        return function e(t, r) {
          let n = t[0],
            a = r[0];
          if (Array.isArray(n) && Array.isArray(a)) {
            if (n[0] !== a[0] || n[2] !== a[2]) return !0;
          } else if (n !== a) return !0;
          if (t[4]) return !r[4];
          if (r[4]) return !0;
          let o = Object.values(t[1])[0],
            i = Object.values(r[1])[0];
          return !o || !i || e(o, i);
        };
      },
    }),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
